export default __webpack_public_path__ + "static/media/feedback.a6d8f274.svg";